/* eslint-disable max-len */
import { VStack } from '@chakra-ui/react';
import { FC } from 'react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { LectureAbstractMarkdown } from '@/components/ui/shared/markdowns/LectureAbstractMarkdown/LectureAbstractMarkdown';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { useResource } from '@/lib/datx-jsonapi-react';

import { LectureKeywords } from './components/LectureKeywords';

export const LectureAbstract: FC = () => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));

  return (
    <VStack alignItems="left" spacing={7}>
      <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
        <LectureKeywords data={lecture} />
      </BugsnagErrorBoundary>
      <LectureAbstractMarkdown source={lecture.abstract} />
    </VStack>
  );
};
